/* eslint-disable @typescript-eslint/no-non-null-assertion */
const cookieButtonChange = (button) => {
    const cookieSDKBtn = document.querySelector("#ot-sdk-btn");
    const MutationObserver = window.MutationObserver;
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            var _a;
            if (mutation.target.textContent != "CookieSettings") {
                const otBtnText = (_a = document.querySelector('#ot-sdk-btn')) === null || _a === void 0 ? void 0 : _a.textContent;
                const mainContent = button === null || button === void 0 ? void 0 : button.querySelector('span[slot="main-content"]');
                if (mainContent && otBtnText) {
                    mainContent.innerHTML = otBtnText;
                }
            }
        });
    });
    const config = { attributes: true, childList: true, characterData: true };
    if (cookieSDKBtn)
        observer.observe(cookieSDKBtn, config);
};
export const cookieListener = () => {
    const shadowList = document.querySelectorAll('section[slot="legal-links"] cipublic-list');
    [...shadowList].forEach((shadowItem) => {
        var _a;
        const shadowLink = (_a = shadowItem === null || shadowItem === void 0 ? void 0 : shadowItem.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('[href="#ot-cookie-btn"]');
        if (shadowLink != null) {
            cookieButtonChange(shadowLink);
            shadowLink.addEventListener('click', (e) => {
                e.preventDefault();
                const otButton = document.querySelector('#ot-sdk-btn');
                if (otButton) {
                    otButton.click();
                }
            });
        }
    });
};
